import asasPattern3 from "assets/asaspattern3.svg";
import crackYellowTemp from "assets/crack-yellow-temp.svg";
import crackDrop from "assets/crack-drop.svg";
import crackPlug from "assets/crack-plug.svg";
import AnalyticalBox from './AnalyticalBox';
import fastWind from "assets/fast-wind.svg";
import { ModalContext } from "hooks/ModalProvider";
import { useContext } from "react";
const rows =
    [
        {
            "id": "RAW-A",
            "label": "Row A",
            "blocks": [
                {
                    "id": "RPP", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "RPP", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "RPP", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },

                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#FDBD4D",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },

                {
                    "id": "2520000461", "status": "free", "color": "#FF5233",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "free", "color": "#FF5233",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#fff",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#FDBD4D",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#FDBD4D",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                },
                {
                    "id": "2520000461", "status": "used", "color": "#FDBD4D",
                    blocks: [
                        {
                            id: "29.1C",
                            type: "Temperature",
                            color: "#FDBD4D",
                            icon: crackYellowTemp,
                        },
                        {
                            id: "30%",
                            type: "Humidity",
                            color: "#fff",
                            icon: crackDrop,
                        },
                        {
                            id: "25.2KW",
                            type: "Power Consumption",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "25.2KW",
                            type: "White Space",
                            color: "#FF5233",
                            icon: crackPlug,
                        },
                        {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                        {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                        },
                    ],
                }

            ]
        },
    ];

interface CrackScreen3Props {
    selectedLayers: string[];

}

const CrackScreen3: React.FC<CrackScreen3Props> = ({ selectedLayers }) => {
    const isOverviewSelected = selectedLayers.includes("Overview");
    const { serversModalShown, setServersModalShown, setRppModalShown } = useContext(ModalContext);
    return (
        <>


            <div className=" w-full flex justify-end " >
                <div className="max-w-[60%]">

                    <div className="flex items-center justify-between gap-4">
                        <AnalyticalBox label={"Crac-3"} />

                        <AnalyticalBox label={"Crac-4"} />
                    </div>



                    <div className=" bg-[#0A3351] max-h-[60vh]  rounded-md h-full my-2 flex justify-center items-center w-full">
                        <div className="content p-4  w-full">
                            {rows.map((row, index) => (
                                <>
                                    {/* Row */}
                                    <div key={row.id} className='cursor-pointer'>
                                        {/* Blocks */}
                                        <div
                                            className={`grid grid-cols-[repeat(19,minmax(0,1fr))] gap-2 ${index === 0 ? "items-end" : "items-start"
                                                } w-full`}
                                        >


                                            {index === 0 && row.blocks.map((block: any) => {

                                                let visibleBlocks: any[] = [];

                                                if (block.blocks && Array.isArray(block.blocks)) {
                                                    visibleBlocks = block.blocks.filter((nested: any) => {
                                                        if (isOverviewSelected) {

                                                            return (
                                                                ["Temperature", "Power Consumption"].includes(nested.type) && block.color === nested.color && ["#FDBD4D", "#FF5233"].includes(block.color)
                                                                //   ["#FDBD4D", "#FF5233"].includes(block.color)
                                                            );
                                                        } else {

                                                            return selectedLayers.includes(nested.type);
                                                        }
                                                    });
                                                }

                                                return (
                                                    <div key={block.id} onClick={() => { block.id === 'RPP' ? setRppModalShown(true) : setServersModalShown(true); }}>

                                                        {visibleBlocks.length > 0 &&
                                                            visibleBlocks.map((nested: any) => {
                                                                if (nested.type === "White Space" && index === 0) {
                                                                    return (
                                                                        <div
                                                                            key={nested.id}
                                                                            className="rounded border-2 h-[70px] w-[26px]"
                                                                            style={{
                                                                                borderColor: block.color || "#D4A017",
                                                                                backgroundImage: `
              repeating-linear-gradient(
                to bottom,
                 ${block.color === "#fff" ? "#537085" : block.color}80 0px,
                ${block.color === "#fff" ? "#537085" : block.color}80 20px,
                ${block.color || ' #d4a017'} 20px,
                ${block.color || ' #d4a017'} 21px
              )
            `,
                                                                                backgroundSize: "100% 21px",
                                                                                backgroundRepeat: "repeat-y",
                                                                            }}
                                                                        >
                                                                            {/* White Space Label */}
                                                                            <span
                                                                                className="text-[10px] font-bold text-[#D4A017] [writing-mode:vertical-rl]"
                                                                                style={{ transform: "rotate(180deg)" }}
                                                                            >
                                                                                {/* {nested.type} */}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                }

                                                                // Normal nested block render
                                                                if (index === 0) {
                                                                    return (
                                                                        <div
                                                                            key={nested.id}
                                                                            className="p-[4px] text-xs font-medium rounded border-2 font-[700] [writing-mode:vertical-rl] h-[80px] flex items-center justify-center gap-2 font-bold"
                                                                            style={{
                                                                                borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                                                                backgroundColor: block.color === "#fff" ? "#537085" : `${block.color}80`,
                                                                                transform: "rotate(180deg)",
                                                                                color: block.color,
                                                                            }}
                                                                        >
                                                                            {nested.id}
                                                                            {nested.icon && (
                                                                                <img src={nested.icon} alt="icon" className="mb-1" />
                                                                            )}
                                                                        </div>
                                                                    );

                                                                }


                                                            })}

                                                        <div
                                                            className={`p-[4px] text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl] h-[80px] flex justify-center`}
                                                            style={{
                                                                borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                                                backgroundColor: `${block.color}80`,
                                                                transform: "rotate(180deg)",
                                                            }}
                                                        >
                                                            {block.id}
                                                        </div>
                                                    </div>
                                                );
                                            })}


                                            {index === 1 && row.blocks.map((block: any) => {

                                                let visibleBlocks: any[] = [];

                                                if (block.blocks && Array.isArray(block.blocks)) {
                                                    visibleBlocks = block.blocks.filter((nested: any) => {
                                                        if (isOverviewSelected) {
                                                            return (
                                                                ["Temperature", "Power Consumption"].includes(nested.type) && block.color === nested.color && ["#FDBD4D", "#FF5233"].includes(block.color)
                                                                //   ["#FDBD4D", "#FF5233"].includes(block.color)
                                                            );
                                                        } else {
                                                            return selectedLayers.includes(nested.type);
                                                        }
                                                    });
                                                }

                                                return (
                                                    <div key={block.id} onClick={() => { block.id === 'RPP' ? setRppModalShown(true) : setServersModalShown(true); }}>
                                                        <div
                                                            className={`p-[4px] text-xs font-medium rounded border-2 font-[700] text-white [writing-mode:vertical-rl] h-[80px] flex justify-center`}
                                                            style={{
                                                                borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                                                backgroundColor: `${block.color}80`,
                                                                transform: "rotate(180deg)",
                                                            }}
                                                        >
                                                            {block.id}
                                                        </div>
                                                        {visibleBlocks.length > 0 &&
                                                            visibleBlocks.map((nested: any) => {
                                                                if (nested.type === "White Space" && index === 1) {
                                                                    return (
                                                                        <div
                                                                            key={nested.id}
                                                                            className="rounded border-2 h-[70px] w-[26px]"
                                                                            style={{
                                                                                borderColor: block.color || "#D4A017",
                                                                                backgroundImage: `
              repeating-linear-gradient(
                to bottom,
               ${block.color === "#fff" ? "#537085" : block.color}80 0px,
                ${block.color === "#fff" ? "#537085" : block.color}80 20px,
                ${block.color || ' #d4a017'} 20px,
                ${block.color || ' #d4a017'} 21px
              )
            `,
                                                                                backgroundSize: "100% 21px",
                                                                                backgroundRepeat: "repeat-y",
                                                                            }}
                                                                        >
                                                                            {/* White Space Label */}
                                                                            <span
                                                                                className="text-[10px] font-bold text-[#D4A017] [writing-mode:vertical-rl]"
                                                                                style={{ transform: "rotate(180deg)" }}
                                                                            >
                                                                                {/* {nested.type} */}
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                }

                                                                // Normal nested block render
                                                                if (index === 1) {
                                                                    return (
                                                                        <div
                                                                            key={nested.id}
                                                                            className="p-[4px] text-xs font-medium rounded border-2 font-[700] [writing-mode:vertical-rl] h-[80px] flex items-center justify-center gap-2 font-bold"
                                                                            style={{
                                                                                borderColor: block.color === "#002E4F4D" ? "#ffffff" : block.color,
                                                                                backgroundColor: block.color === "#fff" ? "#537085" : `${block.color}80`,
                                                                                transform: "rotate(180deg)",
                                                                                color: block.color,
                                                                            }}
                                                                        >
                                                                            {nested.id}
                                                                            {nested.icon && (
                                                                                <img src={nested.icon} alt="icon" className="mb-1" />
                                                                            )}
                                                                        </div>
                                                                    );

                                                                }


                                                            })}






                                                    </div>
                                                );
                                            })}


                                        </div>

                                        {/* Row Label */}
                                        <div className="row-title rounded-md flex items-center justify-center  w-[30px]">
                                            <h4 className="text-sm font-semibold text-white [writing-mode:vertical-rl] rotate-180">
                                                {row.label}
                                            </h4>
                                        </div>

                                    </div>
                                    {rows.length - 1 !== index && rows.length > 1 && (

                                        <div className="flex h-full relative overflow-hidden"
                                            style={{ width: "calc(100% - 30px)" }}
                                        >

                                            <img src={asasPattern3} alt="asas-pattern" className='w-full h-full' />

                                        </div>
                                    )}
                                </>
                            ))}

                        </div>

                    </div>


                    <div className="flex items-center justify-center gap-5">
                        <AnalyticalBox label={"Crac-6"} />
                        <AnalyticalBox label={"Crac-7"} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CrackScreen3;